import React, { useEffect, useRef, useState } from 'react';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import {
  ComposableMap,
  Geographies,
  Geography,
  Marker,
} from 'react-simple-maps';
import mapStyles from './MapChart.module.css';
import { useKpiData } from 'utils/samarth-dashboard-context/hooks/useKpiData';
import Alerttooltip from './alert-tooltip/alerttooltip';
import { MapFilters } from 'utils/samarth-dashboard-context/constants/samarth-dashboard-constants';
import { Person2Outlined, ReportProblemOutlined } from '@mui/icons-material';
import { getRegionFromState } from 'utils/samarth-dashboard-context/utils/dataTransformers';
import { useSamarthDashboardContext } from 'utils/samarth-dashboard-context/hooks/useSamarthDashboardContext';
import { INDIA_JSON } from './india_json';

const INDIA_GEO_JSON = INDIA_JSON;

const getSvgAccordingToAlert = (icon) => {
  const renderIcon = (
    bgColor,
    IconComponent,
    icon,
  ) => (
    <svg
      className="text-white"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="10" cy="10" r="10" fill={bgColor} />
      {IconComponent ? (
        <IconComponent
          className="w-1 h-1 text-white"
          width={16}
          height={16}
          x={2}
          y={1}
        />
      ) : (
      <svg x={2} y={1} >
        {icon}
      </svg>
      )}
    </svg>
  );

  switch (icon) {
    case 'alert':
      return renderIcon('#ef4444', ReportProblemOutlined);   
    case 'poweroutage':
      return renderIcon(
        '#FA812F',
        null,
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          x={3}
          y={1}
        >
          <g clipPath="url(#clip0_1196_1169)">
            <path
              d="M6.23573 12.063H3.73991C3.52827 12.063 3.3562 12.2358 3.3562 12.4474C3.3562 12.6591 3.52827 12.8318 3.73991 12.8318H6.23573C6.44737 12.8318 6.61944 12.6591 6.61944 12.4474C6.61944 12.2358 6.44737 12.063 6.23573 12.063Z"
              fill="white"
            />
            <path
              d="M3.9274 13.419C3.9274 14.0033 4.41716 14.4612 5.00143 14.4612C5.5857 14.4612 6.07546 14.0035 6.07546 13.419V13.2614H3.9274V13.419Z"
              fill="white"
            />
            <path
              d="M9.46152 3.63971C9.41811 3.5002 9.18295 2.81327 8.57019 2.1164C8.1806 1.67322 7.7173 1.31596 7.1934 1.05458C6.54672 0.73169 5.81005 0.556906 5.00464 0.535425L4.9879 0.534973L4.97208 0.535425C4.16599 0.556906 3.42909 0.73169 2.78241 1.05458C2.25851 1.31619 1.79521 1.67345 1.40562 2.11662C0.792403 2.81395 0.557473 3.50043 0.514285 3.63994C0.211522 4.50255 0.123338 5.34708 0.252222 6.14978C0.356685 6.80053 0.602469 7.41962 0.982563 7.9901C1.56525 8.86425 2.28361 9.34948 2.43759 9.44739C2.81655 9.73342 2.81836 10.0993 2.81475 10.17C2.81271 10.208 2.81361 10.2392 2.81407 10.2621V10.2765C2.80864 10.9194 3.15934 11.2775 3.36917 11.425C3.52858 11.5371 3.7167 11.6111 3.9132 11.6111H6.06261C6.2591 11.6111 6.44723 11.5371 6.60686 11.425C6.81647 11.2775 7.16739 10.9268 7.16151 10.2849V10.2655C7.16219 10.2428 7.16287 10.2098 7.16106 10.1723C7.15744 10.1015 7.15925 9.73455 7.53822 9.44852C7.69242 9.35061 8.41033 8.86515 8.99325 7.99078C9.37357 7.42052 9.61935 6.80098 9.72359 6.15023C9.85247 5.34753 9.76429 4.50278 9.46152 3.63994V3.63971ZM6.73462 6.6479C6.88566 6.79894 6.88566 7.04382 6.73462 7.19464C6.6591 7.27016 6.56006 7.30792 6.46125 7.30792C6.36244 7.30792 6.2634 7.27016 6.18788 7.19464L4.98496 5.99172L3.78205 7.19464C3.70653 7.27016 3.60749 7.30792 3.50868 7.30792C3.40987 7.30792 3.31083 7.27016 3.23531 7.19464C3.08427 7.0436 3.08427 6.79872 3.23531 6.6479L4.43823 5.44499L3.23531 4.24207C3.08427 4.09103 3.08427 3.84615 3.23531 3.69534C3.38636 3.54429 3.63123 3.54429 3.78205 3.69534L4.98496 4.89825L6.18788 3.69534C6.33892 3.54429 6.5838 3.54429 6.73462 3.69534C6.88566 3.84638 6.88566 4.09126 6.73462 4.24207L5.5317 5.44499L6.73462 6.6479Z"
              fill="white"
            />
          </g>
          <defs>
            <clipPath id="clip0_1196_1169">
              <rect
                width="9.58623"
                height="13.9262"
                fill="white"
                transform="translate(0.195068 0.534973)"
              />
            </clipPath>
          </defs>
        </svg>,
      );
    case 'Plant Closure': return renderIcon(
        '#FA812F',
        null,
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          x={3}
          y={1}
        >
          <g clipPath="url(#clip0_1196_1169)">
            <path
              d="M6.23573 12.063H3.73991C3.52827 12.063 3.3562 12.2358 3.3562 12.4474C3.3562 12.6591 3.52827 12.8318 3.73991 12.8318H6.23573C6.44737 12.8318 6.61944 12.6591 6.61944 12.4474C6.61944 12.2358 6.44737 12.063 6.23573 12.063Z"
              fill="white"
            />
            <path
              d="M3.9274 13.419C3.9274 14.0033 4.41716 14.4612 5.00143 14.4612C5.5857 14.4612 6.07546 14.0035 6.07546 13.419V13.2614H3.9274V13.419Z"
              fill="white"
            />
            <path
              d="M9.46152 3.63971C9.41811 3.5002 9.18295 2.81327 8.57019 2.1164C8.1806 1.67322 7.7173 1.31596 7.1934 1.05458C6.54672 0.73169 5.81005 0.556906 5.00464 0.535425L4.9879 0.534973L4.97208 0.535425C4.16599 0.556906 3.42909 0.73169 2.78241 1.05458C2.25851 1.31619 1.79521 1.67345 1.40562 2.11662C0.792403 2.81395 0.557473 3.50043 0.514285 3.63994C0.211522 4.50255 0.123338 5.34708 0.252222 6.14978C0.356685 6.80053 0.602469 7.41962 0.982563 7.9901C1.56525 8.86425 2.28361 9.34948 2.43759 9.44739C2.81655 9.73342 2.81836 10.0993 2.81475 10.17C2.81271 10.208 2.81361 10.2392 2.81407 10.2621V10.2765C2.80864 10.9194 3.15934 11.2775 3.36917 11.425C3.52858 11.5371 3.7167 11.6111 3.9132 11.6111H6.06261C6.2591 11.6111 6.44723 11.5371 6.60686 11.425C6.81647 11.2775 7.16739 10.9268 7.16151 10.2849V10.2655C7.16219 10.2428 7.16287 10.2098 7.16106 10.1723C7.15744 10.1015 7.15925 9.73455 7.53822 9.44852C7.69242 9.35061 8.41033 8.86515 8.99325 7.99078C9.37357 7.42052 9.61935 6.80098 9.72359 6.15023C9.85247 5.34753 9.76429 4.50278 9.46152 3.63994V3.63971ZM6.73462 6.6479C6.88566 6.79894 6.88566 7.04382 6.73462 7.19464C6.6591 7.27016 6.56006 7.30792 6.46125 7.30792C6.36244 7.30792 6.2634 7.27016 6.18788 7.19464L4.98496 5.99172L3.78205 7.19464C3.70653 7.27016 3.60749 7.30792 3.50868 7.30792C3.40987 7.30792 3.31083 7.27016 3.23531 7.19464C3.08427 7.0436 3.08427 6.79872 3.23531 6.6479L4.43823 5.44499L3.23531 4.24207C3.08427 4.09103 3.08427 3.84615 3.23531 3.69534C3.38636 3.54429 3.63123 3.54429 3.78205 3.69534L4.98496 4.89825L6.18788 3.69534C6.33892 3.54429 6.5838 3.54429 6.73462 3.69534C6.88566 3.84638 6.88566 4.09126 6.73462 4.24207L5.5317 5.44499L6.73462 6.6479Z"
              fill="white"
            />
          </g>
          <defs>
            <clipPath id="clip0_1196_1169">
              <rect
                width="9.58623"
                height="13.9262"
                fill="white"
                transform="translate(0.195068 0.534973)"
              />
            </clipPath>
          </defs>
        </svg>,
      );
    case 'flood':
      return renderIcon(
        '#FA812F',
        null,
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
        >
          <g clipPath="url(#clip0_1196_6752)">
            <path
              d="M2.96629 11.8911C3.57197 12.0294 3.93364 12.3127 4.26851 12.6195C4.52157 12.8516 4.62669 12.9479 5.05415 12.9479C5.32044 12.9479 5.52025 12.8197 5.88052 12.5746C6.35984 12.2479 7.01635 11.8008 8.08116 11.8008C9.14597 11.8008 9.80282 12.2479 10.2825 12.5746C10.6424 12.8197 10.8426 12.9479 11.1089 12.9479C11.3553 12.9479 11.529 12.8324 11.8688 12.5911C12.1956 12.3593 12.6071 12.0687 13.1964 11.9128V9.08077H15.3149L12.1799 5.92725V3.20373H10.5164V4.25385L8.08081 1.8045L0.847457 9.08077H2.96595L2.96629 11.8911ZM8.43134 7.36395H9.48641V8.42493H8.43134V7.36395ZM8.43134 8.9288H9.48641V9.98978H8.43134V8.9288ZM6.87537 7.36395H7.93009V8.42493H6.87537V7.36395ZM6.87537 8.9288H7.93009V9.98978H6.87537V8.9288ZM15.5951 13.4682L15.0834 14.5831C14.9699 14.5303 14.5438 14.2845 14.1341 14.2838C12.9506 14.2838 12.7418 15.4298 11.1085 15.4298C9.47527 15.4298 9.17765 14.2831 8.08081 14.2831C6.98397 14.2831 6.7062 15.4298 5.0538 15.4298C3.40141 15.4298 3.21135 14.2838 2.02784 14.2838C1.61883 14.2845 1.19102 14.5306 1.07859 14.5831L0.566895 13.4682C1.0034 13.1888 1.54712 13.0537 2.08666 13.0635C3.98063 13.0635 3.53334 14.2085 5.0538 14.2085C6.16317 14.2085 6.53946 13.0614 8.08081 13.0614C9.62216 13.0614 9.9988 14.2085 11.1085 14.2085C12.2182 14.2085 12.5051 13.0635 14.0753 13.0635C14.6152 13.054 15.1582 13.1892 15.5951 13.4682Z"
              fill="white"
            />
          </g>
          <defs>
            <clipPath id="clip0_1196_6752">
              <rect
                width="15.0282"
                height="16.1016"
                fill="white"
                transform="translate(0.566895 0.566345)"
              />
            </clipPath>
          </defs>
        </svg>,
      );
    default:
      return renderIcon('#FA812F', Person2Outlined);;
  }
};

const MapChart = () => {
  const [zoom, setZoom] = useState(1);
  const [tooltipContent, setTooltipContent] = useState(null);
  const [tooltipPosition, setTooltipPosition] = useState({ x: 0, y: 0 });
  const [showTooltip, setShowTooltip] = useState(false);
  const { setNewGlobalFilters ,fetchGlobalFilters, refreshAllKpiData, state} = useSamarthDashboardContext();
  const filterLoader = state.dashboardData.isLoading.globalFilter;
  const overallFilters = useKpiData();
  const filters = overallFilters?.filters?.mapfilters;
  const scrollBarRef = useRef(null);
  const { data : chartData} = useKpiData('mapMarkers');
  const { data : internalMarkers } = useKpiData('internalMarkers');

  const filterByRegionState = (
    data,
    fromOther = false
  ) => {
    if (!data) return [];

    if (filters?.region?.length) {
      return data.filter((item) =>
        filters.region.includes(fromOther ? getRegionFromState(item.state || item.State) : item.region),
      );
    }
    if (filters?.state?.length) {
      return data.filter((item) =>
        item?.state || item.State ? filters.state.includes(item.state || item.State) : false,
      );
    }
    return data;
  };

  const finalChartData = filterByRegionState(chartData);

  const filteredRmpmMarkers = filterByRegionState(
    internalMarkers?.rmpm_alerts?.map_data, true
  );
  const filteredMdMarkers = filterByRegionState(
    internalMarkers?.md_alerts?.map_data, true
  );

  const containerRef = useRef(null);

  const handleMouseEnter = (e, name, type, kpi) => {
    setTooltipContent(<Alerttooltip name={name} type={type} kpi={kpi} />);

    const container = containerRef.current?.getBoundingClientRect();

     if (container) {
    const x = (e.clientX);
    const y = (e.clientY);
    setTooltipPosition({ x, y });
    setShowTooltip(true);
  }
  };

  const handleMouseLeave = () => setShowTooltip(false);

  useEffect(() => {

    const scrollableContainer = scrollBarRef.current;

    const handleClickOutside = (event) => {
      if (!(event.target)?.closest?.(`.${mapStyles.alertMarker}`)) {
        handleMouseLeave();
      }
    };
    document.addEventListener('click', handleClickOutside);
    scrollableContainer?.addEventListener('scroll', handleMouseLeave);

  return () => {
    document.removeEventListener('click', handleClickOutside);
    scrollableContainer?.removeEventListener('scroll', handleMouseLeave);
  };
  }, []);

  return (
    <Box className={`${mapStyles.wrapper} no-scrollbar`} ref={scrollBarRef}>
      <Box className={mapStyles.controls}>
        <div className={mapStyles.zoomIcons} onClick={() => setZoom(Math.min(zoom + 0.5, 8.5))}>
          +
        </div>
        <div className={mapStyles.zoomIcons}  onClick={() => setZoom(Math.max(1, zoom - 0.5))}>
          -
        </div>
        <IconButton size="small" onClick={() => setZoom(1)}>
          <img src="/assets/cursor.svg" alt="Reset cursor" width={38} />
        </IconButton>
      </Box>

      {/* Map Container */}
      <Box className={`${mapStyles.mapContainer} no-scrollbar`} ref={containerRef} sx={{ width: 400 * zoom, height: 400 * zoom }}>
        <ComposableMap
          projection="geoMercator"
          projectionConfig={{ center: [90.8777, 20.076], scale: 800 }}
          viewBox="0 0 500 500"
        >
          {/* India geographies */}
          <Geographies geography={INDIA_GEO_JSON}>
            {({ geographies }) =>
              geographies.map((geo) => (
                <Geography
                  key={geo.rsmKey}
                  geography={geo}
                  style={{
                      default: {
                        fill: '#001F82',
                        outline: 'none',
                        stroke: '#ffffff60',
                      },
                      hover: {
                        fill: '#001F82',
                        outline: 'none',
                        stroke: '#ffffff60',
                      },
                      pressed: {
                        fill: '#001F82',
                        outline: 'none',
                        stroke: '#ffffff60',
                      },
                    }}
                />
              ))
            }
          </Geographies>

          {/* External alerts */}
          {finalChartData.map(({ risk_type: name, lat, lng, icon , facilities_affected}, index) => (
            <Marker key={`${name}${lat}${lng}${index}`} coordinates={[lng, lat]}>
              <circle r={10} fill="none" stroke="#f97316" strokeWidth={2} className={mapStyles.pulse} />
              <svg
                height={24 - zoom * 2}
                width={24 - zoom * 2}
                viewBox="0 0 24 24"
                x={-10 + zoom}
                y={-10 + zoom}
              >
                {getSvgAccordingToAlert(icon)}
                <rect
                  width={30}
                  height={30}
                  x={-12}
                  y={-12}
                  fill="transparent"
                  className={`${mapStyles.alertMarker}`}
                  onMouseEnter={(e) => handleMouseEnter(e, name, "rmpm", facilities_affected)}
                  onClick={(e) => handleMouseEnter(e, name, "rmpm", facilities_affected)}
                />
              </svg>
            </Marker>
          ))}

          {/* Internal alerts – RMPM / MD */}
          {filters?.[MapFilters.TYPE] &&
            (filters?.[MapFilters.TYPE] === 'RMPM Shortage'
              ? filteredRmpmMarkers?.map(({ data, latitude, longitude, plant_code, plant_name }, idx) => (
                  <Marker key={`${latitude}${longitude}${plant_code}${idx}`} coordinates={[longitude, latitude]}>
                    <circle r={10} fill="none" stroke="#FF2828" strokeWidth={2} className={mapStyles.pulse} />
                    <svg
                      height={24 - zoom * 2}
                      width={24 - zoom * 2}
                      viewBox="0 0 24 24"
                      x={-10 + zoom}
                      y={-10 + zoom}
                    >
                      {getSvgAccordingToAlert('alert')}
                      <rect
                        width={30}
                        height={30}
                        x={-12}
                        y={-12}
                        fill="transparent"
                        className={mapStyles.alertMarker}
                        onMouseEnter={(e) => handleMouseEnter(e, plant_name, 'rmpm', data)}
                        onClick={() => {
                          if(filterLoader) return;
                          setNewGlobalFilters({ values_mapping : [plant_code]})
                          fetchGlobalFilters({ Factory : [plant_code]}).then(() => {
                             refreshAllKpiData();
                            });
                        }}
                      />
                    </svg>
                  </Marker>
                ))
              : filteredMdMarkers?.map(({ data, latitude, longitude, site_code, site_name }, idx) => (
                  <Marker key={`${latitude}${longitude}${site_code}${idx}`} coordinates={[longitude, latitude]}>
                    <circle r={10} fill="none" stroke="#FF2828" strokeWidth={0.2} className={mapStyles.pulse} />
                    <svg
                      height={24 - zoom * 2}
                      width={24 - zoom * 2}
                      viewBox="0 0 24 24"
                      x={-10 + zoom}
                      y={-10 + zoom}
                    >
                      {getSvgAccordingToAlert('alert')}
                      <rect
                        width={30}
                        height={30}
                        x={-12}
                        y={-12}
                        fill="transparent"
                        className={mapStyles.alertMarker}
                        onMouseEnter={(e) => handleMouseEnter(e, site_name, 'md', data)}
                        onClick={() => {
                          if(filterLoader) return;
                          setNewGlobalFilters({ values_mapping : [site_code]})
                          fetchGlobalFilters({ Factory : [site_code]}).then(() => {
                             refreshAllKpiData();
                            });
                        }}
                      />
                    </svg>
                  </Marker>
                )))}
        </ComposableMap>

      {showTooltip && (
        <Tooltip
          open={true}
          title={tooltipContent}
          placement="top"
          PopperProps={{
            anchorEl: { getBoundingClientRect: () => ({ top: tooltipPosition.y, left: tooltipPosition.x, width: 0, height: 0 }) },
          }}
        />
      )}

      </Box>
    </Box>
  );
};

export default MapChart;
